// import request from '@/utils/request'

// export function getToken() {
//   return request({
//     url: '/qiniu/upload/token', // 假地址 自行替换
//     method: 'get'
//   })
// }\
import request from "./api.js";
import websiteRequest from "./websiteApi.js";

// 登录、注册
export function checkIn(params) {
  return request({
    url: "/api/medium.user/checkIn",
    data: params,
    method: "post",
  });
}

// 退出登录
export function logout() {
  return request({
    url: "/api/medium.user/logout",
    method: "post",
  });
}

// 获取用户信息
export function getuserinfoApi() {
  return request({
    url: "/api/medium.user/index",
    method: "get",
  });
}

// 获取用户信息
export function editApi(params) {
  return request({
    url: "/api/medium.user/edit",
    params: params,
    method: "get",
  });
}

// 保存用户信息
export function editSaveApi(data) {
  return request({
    url: "/api/medium.user/edit",
    data: data,
    method: "post",
  });
}

// 获取微信用户信息
export function getWechatInfoApi(params) {
  return request({
    url: "/api/medium.user/wechatInfo",
    params: params,
    method: "get",
  });
}

// 获取微信用户信息
export function sendCodeApi(params) {
  return request({
    url: "/api/medium.user/sendCode",
    params: params,
    method: "get",
  });
}

// 获取园区信息
export function getParksApi() {
  return request({
    url: "/api/medium.user/parks",
    method: "get",
  });
}

// 获取区域信息
export function getAreasApi() {
  return request({
    url: "/api/medium.user/areas",
    method: "get",
  });
}

// 录入客户信息
export function createCustom(params) {
  return request({
    url: "/api/medium.custom/create",
    data: params,
    method: "post",
  });
}

// 客户列表
export function listShowingApi(params) {
  return request({
    url: "/api/medium.custom/index",
    params: params,
    method: "get",
  });
}

// 客户详情
export function detailShowingApi(params) {
  return request({
    url: "/api/medium.custom/detail",
    params: params,
    method: "get",
  });
}

// 获取编辑客户详情
export function editGetCustom(params) {
  return request({
    url: "/api/medium.custom/edit",
    params: params,
    method: "get",
  });
}

// 编辑客户信息
export function editSaveCustom(params) {
  return request({
    url: "/api/medium.custom/edit",
    data: params,
    method: "post",
  });
}

// 撤回客户信息
export function revokeCustom(params) {
  return request({
    url: "/api/medium.custom/revoke",
    data: params,
    method: "post",
  });
}

// 进展记录列表
export function indexEvolve(params) {
  return request({
    url: "/api/medium.evolve/index",
    params: params,
    method: "get",
  });
}
// 添加进展记录
export function createEvolve(params) {
  return request({
    url: "/api/medium.evolve/create",
    data: params,
    method: "post",
  });
}
// 我的二维码
export function getAgentQrcode(params) {
  return request({
    url: "/api/medium.user/createQrcode",
    params: params,
    method: "get",
  });
}

// 文字识别
export function recognitionApi(params) {
  return request({
    url: "/api/medium.user/split",
    data: params,
    method: "post",
  });
}

// 后台用户授权
export function updateAdmin(params) {
  return websiteRequest({
    url: "/api/user/adminWxUpdate",
    params: params,
    method: "get",
  });
}

// 微信登录
export function wxLogin(params) {
  return websiteRequest({
    url: "/api/wxUser/wxLogin",
    params: params,
    method: "get",
  });
}

// 微信登录-状态：待授权
export function wxEntered(params) {
  return websiteRequest({
    url: "/api/wxUser/wxEntered",
    params: params,
    method: "get",
  });
}

// 样品申请
// 申请列表
export function listApplicationApi(params) {
  return websiteRequest({
    url: "/api/medium.Application/index",
    params: params,
    method: "get",
  });
}

// 申请详情
export function detailApplicationApi(params) {
  return websiteRequest({
    url: "/api/medium.Application/detail",
    params: params,
    method: "get",
  });
}

// 撤回申请信息
export function checkApplication(params) {
  return websiteRequest({
    url: "/api/medium.Application/check",
    data: params,
    method: "post",
  });
}
